var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "visitorMailList" } },
    [
      _c("NewMailInterface", {
        attrs: {
          mode: "folder-only",
          defaultMode: "normal",
          "default-selected-folder": _vm.selectedFolder,
          "default-selected-email-id": _vm.selectedEmailId,
          "visitor-email-address": _vm.visitorMail,
          "ref-visitor-id": _vm.visitorId,
          "enabled-select-sender": true,
        },
        on: { "folder-selected": _vm.changeFolder },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }